import React, { Component, createRef } from "react";
import { StyleSheet, View, TextInput, Text, TouchableOpacity, Platform } from "react-native";
import { connect } from "react-redux";
import NewIssue from "../dialogs/newIssue";
import { searchPackagingMaterials } from "../../actions/records";
import colors from "../../constants/colors";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { sortSearch } from "../../utils";
import { isMobileWeb, getNoAutofillProps, noAutofillRef } from "../../utils/mobileWeb";
class SearchPackaging extends Component {
    constructor(props) {
        super(props);
        this._interval = null;
        this.state = {
            value: props.initial ? props.initial : "",
            height: 30,
            items: [],
            wasEdited: false
        };
        this.textInputRef = createRef(null);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.initial != this.props.initial) {
            this.setState({ value: nextProps.initial });
        }
        if (nextProps.closeSearch != this.props.closeSearch && !this.textInputRef.current?.isFocused()) {
            this.setState({ items: [], wasEdited: false });
            if (this.props.setTableSearchOpen) this.props.setTableSearchOpen(false);
        }
    }
    componentWillUnmount() {
        if (this._interval) clearInterval(this._interval);
        if (this.props.setTableSearchOpen) this.props.setTableSearchOpen(false);
    }
    searchItems(val, focused) {
        const { onSelectItem, resetDropDown } = this.props;
        if(this._interval)clearInterval(this._interval);
        if (val || focused)
            this.props.searchPackagingMaterials({ page: 1, name: val }, (res) => {
                if (res?.packagingMaterials?.length > 0) {
                    const ordered = res?.packagingMaterials.slice().sort((a, b) => sortSearch(a, b, val));
                    this.setState({ items: ordered });
                    if (this.props.setTableSearchOpen) this.props.setTableSearchOpen(true);
                } else {
                    this.setState({ items: [] });
                    if (this.props.setTableSearchOpen) this.props.setTableSearchOpen(false);
                    if(!focused)onSelectItem(val, null);
                }
                if(resetDropDown)resetDropDown();
            });
        else {
            this.setState({ items: [] });
            if (this.props.setTableSearchOpen) this.props.setTableSearchOpen(false);
        }
    }
    render() {
        const { value, items, wasEdited } = this.state;
        const { defaultComponent, onSelectItem, width, isRecipe, defaultLabel, isInventoryReceivingForm, inventoryTableDesign, isShipmentLog, setShowTextBar, isInventoryTransfer } = this.props;
        const inventoryTableCellDesign = !!(isInventoryReceivingForm || inventoryTableDesign);

        return <View>
            <TextInput
                {...getNoAutofillProps()}
                value={value}
                ref={noAutofillRef(this.textInputRef)}
                editable={!defaultComponent}
                onContentSizeChange={(event) => {
                    if (event.nativeEvent.contentSize.height == 0) {
                        if (this.props.placeholder == '') {
                            this.setState({ height: 30 })
                        }
                        this.setState({ height: event.nativeEvent.contentSize.height });
                    } else {
                        setTimeout(() => {
                            this.setState({ height: event.nativeEvent.contentSize.height });
                        }, 5)
                    }
                }}
                onFocus={()=>{
                    if(!defaultComponent && !value){
                        if(this._interval)clearInterval(this._interval);
                        this._interval = setInterval(() => this.searchItems(value ? value : "", true), 500);
                    }
                    /* Same as iqops2: clear KeyboardBar when focus moves to a non-lot search field */
                    if (setShowTextBar && (isMobileWeb() || Platform.OS === "android")) {
                        setShowTextBar(null, null, null, null, null, null, null, false);
                    }
                }}
                style={{...styles.input,
                    borderColor: "#e7e7e7",
                    borderRadius: 5,
                    borderWidth: ((inventoryTableCellDesign && defaultLabel == "yield") || (inventoryTableCellDesign && width && defaultLabel != "preparationInstructions")) ? 0 : 1,
                    color: "#424242",
                    fontFamily: "Roboto",
                    fontSize: inventoryTableCellDesign ? 16 : 20,
                    fontWeight: "400",
                    padding: 5,
                    height: this.state.height,
                    fontStyle: this.state.value ? this.state.value.length == 0 ? 'italic' : 'normal' : 'normal',
                    overflow: 'hidden',
                    textAlign: inventoryTableCellDesign ? 'center' : 'left',
                }}
                multiline={true}
                placeholder={"Enter text to search packaging materials"}
                placeholderTextColor={'rgb(0, 47, 108)'}
                onChangeText={(val) => {
                    if (val == '' && this.props.placeholder == '') {
                        this.setState({ value: val, height: 30, wasEdited: true });

                    } else {
                        this.setState({ value: val, wasEdited: true });
                    }
                    if(this._interval)clearInterval(this._interval);
                    this._interval = setInterval(() => this.searchItems(val, false), 500);
                }}
            />
            {
                items?.length > 0 &&
                items.map((item, idx) => {
                    return <TouchableOpacity key={idx} style={{ ...styles.row, gridTemplateColumns: width == "mini" ? "80% 20%" : isInventoryReceivingForm ? "82% 18%" : "90% 10%"}} onPress={() => {
                        
                        if(isShipmentLog){
                            var newItem = JSON.parse(JSON.stringify(item));
                            //newItem.lotSelected = ["default_lot"]; 
                            onSelectItem(item?.namePackaging, newItem);
                            this.setState({ items: [], value: item?.namePackaging, wasEdited: false });
                        }else{
                            onSelectItem(item?.namePackaging, item)
                            this.setState({ items: [], value: item?.namePackaging, wasEdited: false });
                        }
                        if (this.props.setTableSearchOpen) this.props.setTableSearchOpen(false);
                    }}>
                        <div style={styles.itemTxt}>
                            {item?.namePackaging}
                        </div>
                        <div>
                            <div style={styles.rowBtn} ><Text>
                                    <MaterialCommunityIcons name="plus" style={styles.selectOption} />
                                </Text>
                            </div>
                        </div>

                    </TouchableOpacity>
                })
            }
            {
                value && items?.length <= 0 && wasEdited && <View>
                    <Text>No packaging material was found</Text>
                </View>
            }
        </View>
    }
}

export default connect((state, ownProps = {}) => ({
    isLoading: state.forms.getIn(["form", "status"]) === "loading",
}), (dispatch, props) => ({
    searchPackagingMaterials: (data, callback) =>
        dispatch(searchPackagingMaterials(data, callback)),
}))(SearchPackaging);

const styles = StyleSheet.create({
    container: {
        flexDirection: "column",
        paddingTop: 5,
        flex: 1,
    },
    input: {
        borderColor: "#e7e7e7",
        borderRadius: 5,
        borderWidth: 1,
        color: "#424242",
        fontFamily: "Roboto",
        fontSize: 22,
        fontWeight: "400",
        paddingLeft: 10,
    },
    label: {
        fontSize: 20,
        color: '#939598',
        fontWeight: '300',
        fontFamily: 'Roboto',

    },
    row: {
        display: "grid",
        width: "100%",
        fontFamily: "Roboto",
        fontSize: 18
    },
    rowBtn:{
        color: colors.selectSearch,
        border: '2px solid',
        borderRadius: 4,
        cursor: 'pointer'
    },
    selectOption: { 
        fontSize: 20, 
        color: colors.selectSearch 
    },
    itemTxt: {
        wordBreak: 'word-break',
        padding: 3
    }
});